module.exports = __webpack_public_path__ + "img/lock-locked.ef2ec899.svg";